import { httpClient } from "@/http";
import { TransferStatus } from "./enums";
import {
  TransferCreate,
  TransferQueryParams,
  TransferRead,
  TransferCheck,
  TransferCorrect,
} from "./types";

export const TransferService = {
  /** 列出轉帳清單 */
  list(params: TransferQueryParams = {}) {
    return httpClient<HttpResponse<{ transfers: TransferRead[] }>>().get(
      "/api/v1/transfers",
      params
    );
  },
  download(params: TransferQueryParams = {}) {
    return httpClient<BlobPart>()
      .get("/api/v1/transfers", { ...params, filetype: "xlsx" })
      .blob();
  },
  /** 讀取轉帳單 */
  read(transferId: string) {
    return httpClient<HttpResponse<{ transfer: TransferRead }>>().get(
      `/api/v1/transfer/${transferId}`
    );
  },
  /** 建立轉帳單 */
  create(data: TransferCreate) {
    return httpClient<HttpResponse<{ transfer: TransferRead }>>().post(
      "/api/v1/transfers",
      data
    );
  },
  /** 作廢訂單 */
  destroy(transferId: string) {
    return httpClient<HttpResponse<{ transfer: TransferRead }>>().patch(
      `/api/v1/transfer/${transferId}`,
      { status: TransferStatus.invalid }
    );
  },
  /** 允許提單 */
  approve(transferId: string) {
    return httpClient<HttpResponse<{ transfer: TransferRead }>>().patch(
      `/api/v1/transfer/${transferId}`,
      { status: TransferStatus.allowed }
    );
  },
  /** 送回調 */
  callback(transferId: string) {
    return httpClient<HttpResponse<{ transfer: TransferRead }>>().get(
      `/api/v1/transfer/${transferId}/callback/0`
    );
  },
  /** 還原代付單 */
  recoverWithdraw(transferId: string) {
    return httpClient<HttpResponse<{ transfer: TransferRead }>>().patch(
      `/api/v1/transfer/${transferId}`,
      { status: TransferStatus.created }
    );
  },
  /** 還原代收單 */
  recoverDeposit(transferId: string) {
    return httpClient<HttpResponse<{ transfer: TransferRead }>>().patch(
      `/api/v1/transfer/${transferId}`,
      { status: TransferStatus.arrived_with_wrong_amount }
    );
  },
  /** 補單 */
  renew(transferId: string, data: TransferCorrect) {
    return httpClient<HttpResponse<{ transfer: TransferRead }>>().patch(
      `/api/v1/transfer/${transferId}`,
      { ...data, status: TransferStatus.checked_and_allowed }
    );
  },
  /** 拒絕提單 */
  reject(transferId: string) {
    return httpClient<HttpResponse<{ transfer: TransferRead }>>().patch(
      `/api/v1/transfer/${transferId}`,
      { status: TransferStatus.refused }
    );
  },
  mute(transferId: string) {
    return httpClient<HttpResponse<{ transfer: TransferRead }>>().patch(
      `/api/v1/transfer/${transferId}`,
      { status: TransferStatus.arrived_with_wrong_amount_and_muted }
    );
  },
  /** 檢核 */
  check(transferId: string, data: TransferCheck) {
    return httpClient<HttpResponse<{ transfer: TransferRead }>>().patch(
      `/api/v1/transfer/${transferId}`,
      data
    );
  },
};
